import React, {Component} from "react"
import {Link} from "gatsby"
import "tachyons"
import Header from "./header"
import Footer from "./footer"
import SEO from "./seo"
import Overlay from "./overlay"

class Layout extends Component {
    constructor(props){
        super(props)
        this.state = {
            offsetY: 0,
            isSticky: false,
            overlay: false,

        }
        this.stickyHeader = this.stickyHeader.bind(this);
        this.setOverlay = this.setOverlay.bind(this)
        this.closeModal = this.closeModal.bind(this)
    }
    componentDidMount(){
        window.addEventListener('scroll', this.stickyHeader);

        document.addEventListener('click', this.closeModal);
    }
    closeModal(e){
        let overlay = document.querySelector('.rdnt-overlay');
        let overlayInner = document.querySelector('.rdnt-overlay-inner');
        let overlayClasses = overlay.classList;

        let active = Array.prototype.indexOf.call(overlayClasses, 'show') !== -1 ? true : false;

        let target = e.target;

        if(active){
           if(overlay.contains(target) && !overlayInner.contains(target)){
               this.setOverlay(false)
           }
        }

    }
    componentWillUnmount(){
        window.removeEventListener('scroll', this.stickyHeader);
        window.removeEventListener('click', this.closeModal);
    }
    stickyHeader(){
        // Determine the offset value based on the pageClass
        const offsetValue = this.props.pageClass === 'Home' ? 200 : (this.props.pageClass === 'Tulsa' ? 220 : 200);
    
        this.setState({offsetY: window.pageYOffset})
        window.pageYOffset > offsetValue ? this.setState({isSticky:true}) : this.setState({isSticky:false})
    }
    setOverlay(val){
        this.setState({overlay: val})
    }
    render(){
        var year = new Date().getFullYear();
        let {children, page, pageClass, desc, className } = this.props
        return (
            <>
                <SEO page={page} desc={desc} />
                <Header sticky={this.state.isSticky} page={pageClass} setOverlay={val => this.setOverlay(val)} />
                    {/* Refactor */}
                    <main className={`clearfix ${pageClass === 'Home' ? 'home' :'inside'} ${className ? className : ''}`}>{children}</main>
                    <div className={`container tc mt5 mb6 ${pageClass === 'home' ? 'show':'hide'}`}>
                        <Link to="/locations" className="button cta mb3 mb0-l mr4-l">View Our Centers</Link>
                        <button className="button clear" onClick={()=>{this.setOverlay(true)}}>Make an Appointment</button>
                    </div>
                <Footer />
                <div className={`clearfix`}>
                    <div style={{background: `#315ea8`, color: `white`}} className="copyright fl tc tl-l w-100 pt3 pb3 pl5-l">
                        <div className="sites">
                            <a href="https://breastlink.com" target="_blank">breastlink.com</a> | <a href="https://www.arizonadiagnosticradiology.com" target="_blank">arizonadiagnosticradiology.com</a> | <a href="https://xrayhours.com" target="_blank">xrayhours.com</a>
                        </div>
                        <div className="container-xs text-center">
                        Copyright &copy; {year} RadNet, Inc. | All rights reserved. Unauthorized use is strictly prohibited.
                        </div>
                    </div>
                </div>
                <Overlay overlay={this.state.overlay} setOverlay={this.setOverlay} />
            </>
        )
    }
}

export default Layout
